import { Autocomplete, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
	multiTextField: {
		'&.MuiFilledInput-root': {
			padding: '26px 65px 10px 9px',
		},
	},
}));

const MultiSelect = ({ options = [], label = '', value = [], onChangeSelect }) => {
	const classes = useStyles();
	const [selectedValue, setSelectedValue] = useState([]);
	const [selectOptions, setSelectOptions] = useState([]);

	useEffect(() => {
		if (options && options.length > 0) {
			setSelectOptions([...options]);
		}
	}, [options]);

	useEffect(() => {
		if (value && value.length > 0) {
			setSelectedValue([...value]);
		}
	}, [value]);

	const changeHandler = (_, newValue) => {
		setSelectedValue(newValue);
		onChangeSelect(newValue);
	};

	return (
		<Autocomplete
			multiple
			key="multi-select-component"
			id="multi-select-box"
			options={selectOptions}
			getOptionLabel={(option) => option.name}
			isOptionEqualToValue={(option, value) => option?.id === value?.id}
			value={selectedValue || []}
			filterSelectedOptions
			onChange={changeHandler}
			renderInput={(params) => (
				<TextField
					variant="filled"
					{...params}
					InputProps={{ ...params.InputProps, className: classes.multiTextField }}
					label={label}
				/>
			)}
		/>
	);
};

export default MultiSelect;
